import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { Reservation } from '../../models/reservation';
import { ReservationDish } from '../../models/reservation-dish';
import { ReservationService } from '../../services/reservation.service';

@Component({
  selector: 'app-reservations-add',
  templateUrl: './reservations-add.component.html',
  styleUrls: ['./reservations-add.component.css']
})

export class ReservationsAddComponent implements OnInit {
  reservation: Reservation;
  errorMessage: string;
  isLoading = true;

  constructor(private reservationService: ReservationService, private router: Router) {

  }

  ngOnInit() {
    this.reservation = new Reservation();
    this.reservation.orderdate = new Date(Date.now());
    this.reservation.dishes = new Array();

    this.reservationService.getDishes().subscribe(dishes => {
      for (let i = 0; i < dishes.length; i++) {
        let resDish = new ReservationDish();
        resDish.dishId = dishes[i].id;
        resDish.dishName = dishes[i].name;
        resDish.unitPrice = dishes[i].price;
        this.reservation.dishes.push(resDish);
      }
      this.isLoading = false;
    });
  }

  addReservation() {
    this.reservationService.addReservation(this.reservation)
            .subscribe(
              x => this.router.navigateByUrl('/reservations'),
              err => this.errorMessage = 'Something went wrong -> ' + err.error + ' (' + err.status + ')');
  }
}



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/pages/reservations-add/reservations-add.component.ts